import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("mb_cookie_consent")) setShow(true);
  }, []);
  if (!show) return null;
  const accept = () => { localStorage.setItem("mb_cookie_consent", "1"); setShow(false); };
  return (
    <div className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:max-w-md z-[60] bg-white brand-shadow rounded-2xl border border-navy/10 p-5" data-testid="cookie-banner">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-orange/10 flex items-center justify-center shrink-0">
          <Cookie className="w-5 h-5 text-orange" />
        </div>
        <div>
          <p className="text-sm text-navy/80 leading-relaxed">
            Utilizziamo i cookie per migliorare la tua esperienza. Continuando accetti la nostra{" "}
            <a href="/legal/cookie" className="text-orange font-medium underline">Cookie Policy</a>.
          </p>
          <div className="flex gap-2 mt-3">
            <Button size="sm" className="rounded-full bg-navy text-white hover:bg-navy-700" onClick={accept} data-testid="cookie-accept-btn">Accetta</Button>
            <Button size="sm" variant="outline" className="rounded-full" onClick={accept} data-testid="cookie-reject-btn">Solo necessari</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
